package io.horion.cv.api.datasource.job

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Job(
    @SerialName("_id")
    val id: String = "",
    val uuid: String = "",
    val enterprise: String? = null,           // nullable côté back
    val title: String = "",
    val city: String = "",
    val type: JobType = JobType.CDI,
    val description: String = "",
    val requirements: List<String> = emptyList(),
    val responsibilities: List<String> = emptyList(),
    val salaryRange: SalaryRange? = null,     // nullable côté back
    val experience: ExperienceLevel = ExperienceLevel.MID,
    val publicateAt: String = "",
    val expire: String? = null,               // nullable côté back
    val contactEmail: String = "",
    val tags: List<String> = emptyList(),
    val isRemote: Boolean = false,
    val status: JobStatus = JobStatus.ACTIVE,
    val createdAt: String = "",
    val updatedAt: String? = null             // nullable côté back
)